import { SvgIcon } from '@mui/material';
import { IconProps } from './types/iconTypes';
const Location2Icon = ({
  color = '$primary-main',
  width = '10',
  height = '14',
  className
}: IconProps) => {
  const svgWidth = `${width}px`;
  const svgHeight = `${height}px`;
  const numericWidth = parseInt(width, 10);
  const numericHeight = parseInt(height, 10);
  return <SvgIcon className={className} style={{
    width: svgWidth,
    height: svgHeight
  }} viewBox={`0 0 ${numericWidth} ${numericHeight}`} xmlns="http://www.w3.org/2000/svg" data-sentry-element="SvgIcon" data-sentry-component="Location2Icon" data-sentry-source-file="Location2Icon.tsx">
			<path d="M5.00008 0.332672C2.42941 0.332672 0.338623 2.42477 0.338623 4.99543C0.338623 7.9841 4.31643 12.8389 4.48576 13.0436L5.00008 13.6673L5.5144 13.0436C5.68374 12.8383 9.66154 7.9841 9.66154 4.99543C9.66154 2.4241 7.57075 0.332672 5.00008 0.332672ZM5.00008 1.66601C6.83541 1.66601 8.32821 3.1601 8.32821 4.99543C8.32821 6.79877 6.25208 9.90028 5.00008 11.5436C3.74808 9.90161 1.67196 6.80143 1.67196 4.99543C1.67196 3.1601 3.16475 1.66601 5.00008 1.66601ZM5.00008 3.32616C4.07941 3.32616 3.33341 4.07216 3.33341 4.99283C3.33341 5.9135 4.07941 6.6595 5.00008 6.6595C5.92075 6.6595 6.66675 5.9135 6.66675 4.99283C6.66675 4.07216 5.92075 3.32616 5.00008 3.32616Z" fill={color} data-sentry-element="path" data-sentry-source-file="Location2Icon.tsx" />
		</SvgIcon>;
};
export default Location2Icon;